export default {
  nav: {
    coreLogic: '核心邏輯',
    profitMechanism: '獲利機制',
    profitFlywheel: '盈利飛輪',
    sysArch: '系統架構',
    tradingExample: '交易案例',
    cta: '開始使用',
    language: '語言',
  },
  hero: {
    badge: 'Poly Ai Claw 智能體引擎',
    title1: '從預測到',
    title2: '概率套利',
    desc: 'Polywin 通過 Poly Ai Claw 智能體引擎，將預測市場升級為系統化套利引擎',
    ctaPrimary: '開啟 Poly Ai Claw 智能體引擎',
    ctaSecondary: '觀看演示',
    statsEvents: '監控事件',
    statsSuccessRate: '執行成功率',
    statsExecTime: '執行時間',
    cardTitle: '概率偏差分析',
    cardBadge: 'EV 優勢區',
    cardMarketProb: '市場概率',
    cardAiProb: 'AI 概率',
    cardMarketImplied: '市場隱含概率',
    cardAiTrue: 'AI 真實概率',
    cardProbDiff: '概率差優勢',
  },
  coreLogic: {
    badge: 'PolyAi-Claw 決策系統',
    title1: '從數據聚合到收益複利的',
    title2: '全自動閉環',
    desc: '通過多源數據 → AI建模 → 概率偏差識別 → 自動執行 → 收益複利，構建完整的自動化交易閉環',
    step0_title: '數據層',
    step0_sub: '多源信息聚合',
    step0_i0: '政治事件',
    step0_i1: '宏觀經濟',
    step0_i2: '社交情緒',
    step0_i3: '盤口數據',
    step1_title: 'AI 建模',
    step1_sub: '貝葉斯概率更新',
    step1_i0: '實時數據輸入',
    step1_i1: 'AI 建模引擎',
    step1_i2: '概率計算',
    step1_i3: '模型優化',
    step2_title: '偏差檢測',
    step2_sub: '概率偏差識別',
    step2_i0: '市場隱含概率',
    step2_i1: 'AI 真實概率',
    step2_i2: 'EV 優勢識別',
    step2_i3: '建倉信號',
    step3_title: '鏈上執行',
    step3_sub: 'Polygon 自動交易',
    step3_i0: '風險控制',
    step3_i1: '資金分配',
    step3_i2: 'USDC 結算',
    step3_i3: '智能合約',
    step4_title: '收益複利',
    step4_sub: '自動再投資',
    step4_i0: '事件結算',
    step4_i1: '收益清算',
    step4_i2: '複利計算',
    step4_i3: '再投資循環',
    keyTitle: '核心目標',
    keyDesc: 'PolyAi-Claw 的目標是持續尋找市場中的概率錯配(Mispricing)並進行系統化套利。',
    keyHighlight: '持續尋找市場中的概率錯配並進行系統化套利',
  },
  profitMechanism: {
    badge: '核心獲利機制',
    title1: 'PolyAi-Claw 的',
    title2: '三大獲利機制',
    desc: '通過 EV 優勢識別、毫秒級執行和三級資金管理，構建穩定的概率套利系統',
    m1_title: 'EV 優勢識別',
    m1_sub: 'Probability Edge Detection',
    m1_desc: '核心判斷邏輯：市場價格 ≠ 真實概率。當 AI 識別到市場隱含概率與真實概率存在偏差時，自動進入 EV 優勢區並觸發建倉。',
    m1_marketImplied: '市場隱含概率',
    m1_aiTrue: 'AI 真實概率',
    m1_probDiff: '概率差優勢',
    m1_note: '與量化基金期權套利策略原理相同',
    m2_title: '毫秒級自動執行',
    m2_sub: 'Millisecond Execution',
    m2_desc: '採用全自動執行框架，確保套利機會不會因人為操作而流失。',
    m2_i0_title: '毫秒級執行速度',
    m2_i0_sub: '平均 <200ms',
    m2_i1_title: '完全鏈上透明',
    m2_i1_sub: 'Polygon PoS',
    m2_i2_title: '無人為干擾',
    m2_i2_sub: '智能合約自動結算',
    m2_network_label: '執行網絡',
    m2_network_val: 'Polygon + USDC',
    m3_title: '三級資金管理',
    m3_sub: 'Three-Tier Risk Control',
    m3_desc: '避免傳統投機行為中的高槓桿與單點風險，設計三層資金結構確保系統長期穩定運行。',
    m3_i0_title: '穩定收益池',
    m3_i0_desc: '高確定性概率套利，風險最低',
    m3_i1_title: '波動套利池',
    m3_i1_desc: '捕捉市場波動，收益彈性高',
    m3_i2_title: '對沖保護池',
    m3_i2_desc: '低相關事件對沖，降低系統風險',
    m3_risk: '單事件風險敞口 < 5%',
    formula_title: '概率差套利公式',
    formula_marketPrice: '市場價格',
    formula_aiTrue: 'AI 真實概率',
    formula_trigger: '觸發建倉',
    formula_arbitrage: '套利',
    formula_hiddenPct: '隱含概率 60%',
    formula_evEdge: 'EV 優勢 +12%',
    formula_autoExec: '自動執行',
  },
  fundManagement: {
    riskTitle: '風險控制核心原則',
    riskDesc: '系統設置單事件最大風險敞口 < 5%，確保即使單個事件出現極端情況，也不會對整體資金池造成重大影響。',
    riskHighlight: '單事件最大風險敞口 < 5%',
    stat_maxSingle: '最大單筆投入',
    stat_maxSingleVal: '5%',
    stat_diversify: '資金分散度',
    stat_diversifyVal: '20+ 事件',
    stat_stopLoss: '止損機制',
    stat_stopLossVal: '自動觸發',
    vizTitle: '風控數據可視化',
    viz_exposure: '風險敞口控制',
    viz_diversify: '資金分散度',
    viz_correlation: '事件相關性',
    viz_stability: '策略穩定性',
  },
  techAdvantage: {
    badge: '核心優勢',
    title1: '為什麼 PolyAi-Claw',
    title2: '優於傳統預測市場？',
    dim_decision: '決策基礎',
    dim_monitor: '監控頻率',
    dim_execute: '執行方式',
    dim_model: '認知模型',
    dim_risk: '風險控制',
    human_decision: '情緒驅動',
    human_monitor: '低頻判斷',
    human_execute: '人為下單',
    human_model: '主觀認知',
    human_risk: '經驗判斷',
    ai_decision: '數據驅動',
    ai_monitor: '高頻監控',
    ai_execute: '自動執行',
    ai_model: '概率模型',
    ai_risk: '算法管理',
    humanPredict: '人類預測',
    adv1_title: '數據驅動 vs 情緒驅動',
    adv1_desc: 'PolyAi-Claw 基於多源數據建模，包括政治事件、宏觀經濟、社交情緒和盤口數據。',
    adv1_label: '數據源數量',
    adv2_title: '高頻監控 vs 低頻判斷',
    adv2_desc: '系統 24/7 不間斷監控市場變化，實時識別概率偏差機會。',
    adv2_label: '監控頻率',
    adv3_title: '自動執行 vs 人為下單',
    adv3_desc: '毫秒級自動執行，通過智能合約在 Polygon 鏈上完成交易，確保套利機會不流失。',
    adv3_label: '執行速度',
    adv4_title: '算法管理 vs 經驗判斷',
    adv4_desc: '三級資金管理系統，單事件風險敞口嚴格控制在 5% 以下。',
    adv4_label: '風險控制',
    conclusion_title: '從預測市場到 Poly Ai Claw 智能體引擎',
    conclusion_desc1: '這使 PolyWin 從一個簡單的 Prediction Market 升級為',
    conclusion_brand: 'Poly Ai Claw 智能體引擎',
    conclusion_desc2: '即 Poly Ai Claw 智能體量化預測系統',
  },
  productNarrative: {
    badge: '產品定位',
    title: 'PolyWin 的真正定位',
    desc: 'PolyWin 並不是一個單純的預測市場，而是一個融合 AI、預測市場、OpenClaw 和量化交易的綜合系統。',
    item0_title: '概率差套利系統',
    item0_sub: '持續捕捉市場定價偏差',
    item1_title: '紀律化執行模型',
    item1_sub: '自動化無情緒干擾',
    item2_title: 'AI 風險管理引擎',
    item2_sub: '智能風控保障安全',
    visual_title: '三大視覺表達',
    vis0_title: '① 概率曲線偏差圖',
    vis0_desc: '展示 AI 概率曲線 vs 市場定價曲線，形成明顯價格偏差區域',
    vis0_ai: 'AI 概率',
    vis0_market: '市場價格',
    vis0_diff: '概率差',
    vis1_title: '② 風控雷達圖',
    vis1_desc: '展示風險敞口、資金分散、事件相關性、策略穩定性',
    vis1_exposure: '風險敞口',
    vis1_diversify: '資金分散',
    vis1_safe: '安全區域',
    vis1_safeVal: '已進入',
    vis2_title: '③ AI 自動交易流程圖',
    vis2_desc: '突出數據 → AI → 執行 → 清算 → 複利的完整閉環',
    vis2_exec: '執行速度',
    vis2_execVal: '毫秒級',
    vis2_auto: '自動化率',
    vis2_compound: '複利循環',
    vis2_compoundVal: '持續',
    core_title: '核心價值主張',
    core_desc: '通過自動化概率定價與時間複利機制，PolyAi-Claw 試圖在保證風險控制的前提下，持續捕捉預測市場中的定價偏差。',
    core_highlight: '自動化概率定價與時間複利機制',
    core_item0: '自動化概率定價',
    core_item1: '時間複利機制',
    core_item2: '風險控制保障',
    core_item3: '持續捕捉偏差',
  },
  profitFlywheel: {
    badge: 'AI驅動金融增長飛輪',
    title1: 'PolyWin AI',
    title2: '盈利飛輪模型',
    desc: 'PolyWin 的增長不依賴單次交易盈利，而是依賴 AI驅動的持續複利系統，形成自增強循環',
    descHighlight: 'AI驅動的持續複利系統',
    aiCore: 'AI Probability Engine',
    step1_title: '全球數據輸入',
    step1_sub: 'Global Data',
    step1_desc: 'AI持續監控新聞事件、政治變化、宏觀經濟數據、社交情緒、預測市場盤口',
    step1_tech: '50+ 數據源',
    step1_techDetail: '多源實時信息流融合',
    step2_title: 'AI概率建模',
    step2_sub: 'Probability Modeling',
    step2_desc: '使用貝葉斯概率模型、情緒修正模型、市場定價模型計算真實概率',
    step2_tech: '貝葉斯模型',
    step2_techDetail: '動態概率實時修正',
    step3_title: '發現概率偏差',
    step3_sub: 'Probability Edge',
    step3_desc: '當AI真實概率 > 市場隱含概率時，識別為EV Positive Opportunity',
    step3_tech: 'EV 偏差 >5%',
    step3_techDetail: '正期望值自動識別',
    step4_title: '自動交易執行',
    step4_sub: 'Algorithmic Execution',
    step4_desc: '系統自動完成建倉、對沖、訂單執行，交易在Polygon鏈上完成',
    step4_tech: '智能合約',
    step4_techDetail: '<200ms 毫秒級執行',
    step5_title: '預測市場獲利',
    step5_sub: 'Market Profit',
    step5_desc: '當事件結果確認或市場概率回歸時，系統獲得套利收益',
    step5_tech: 'Polygon PoS',
    step5_techDetail: '鏈上結果自動清算',
    step6_title: '收益回收',
    step6_sub: 'Capital Recycling',
    step6_desc: '系統將盈利資金自動回收至資金池',
    step6_tech: 'USDC 結算',
    step6_techDetail: '穩定幣零匯率損耗',
    step7_title: '複利增長',
    step7_sub: 'Compounding Capital',
    step7_desc: '資金池規模擴大後，AI可以參與更大市場、更多事件、更多套利機會',
    step7_tech: '自動複利',
    step7_techDetail: '收益自動再投資循環',
    step8_title: '更大資金規模',
    step8_sub: 'Larger Liquidity Pool',
    step8_desc: '更大的資金規模意味著更高交易能力、更穩定收益、更強市場影響力',
    step8_tech: '流動性擴容',
    step8_techDetail: '規模越大優勢越強',
    sum0_label: '數據層',
    sum0_tech: '50+ 多源數據流',
    sum0_detail: '貝葉斯實時建模',
    sum1_label: '執行層',
    sum1_tech: '智能合約自動化',
    sum1_detail: 'Polygon PoS 鏈上結算',
    sum2_label: '結算層',
    sum2_tech: 'USDC 穩定幣',
    sum2_detail: '零匯率損耗清算',
    sum3_label: '複利層',
    sum3_tech: '自動再投資',
    sum3_detail: '規模擴容正循環',
    key0_title: '自增強循環',
    key0_desc: '每次盈利都會增強系統能力，形成正向反饋循環，實現指數級增長',
    key1_title: 'AI驅動增長',
    key1_desc: '增長不依賴拉人，而是依賴AI系統本身的概率套利能力和複利效應',
    key2_title: '持續複利系統',
    key2_desc: '通過自動化收益回收和再投資，實現資金規模的持續擴大和收益穩定增長',
    formula_title: '飛輪增長公式',
    f0_label: 'AI數據',
    f1_label: '概率套利',
    f2_label: '獲利',
    f3_label: '複利',
    f4_label: '更大資金',
    f5_label: '更多套利',
    connected: '已連接 · 實時',
  },
  sysArch: {
    badge: 'Official Architecture',
    title1: 'PolyAi-Claw AI',
    title2: '系統架構圖',
    desc: '從數據採集到自動結算的完整 AI 決策系統，採用量化基金級風控模型',
    coreBadge: '核心 AI 大腦',
    feat0_title: 'AI 系統結構完整',
    feat0_desc: '不是簡單策略，而是完整的 AI 決策系統，涵蓋數據採集、智能分析、風險控制到自動執行的全流程',
    feat1_title: '量化基金級風控',
    feat1_desc: '採用專業量化基金的風險控制模型，包括敞口控制、相關性對沖和動態資金分配',
    feat2_title: '可擴展架構',
    feat2_desc: '未來可擴展至多市場、多鏈、多策略',
    dataflow_title: '數據流向',
  },
  tradingExample: {
    badge: '實戰案例解析',
    title1: 'PolyAi-Claw BTC',
    title2: '5分鐘套利策略',
    desc: '系統只做三件事：識別異常波動 → 最後60秒概率判斷 → 安全區交易',
    s1_title: 'BTC Market Data',
    s1_sub: '實時市場監控',
    s1_notice: '以下為策略觸發條件示例數據',
    s1_price: '當前價格',
    s1_eg: '舉例',
    s1_priceVol: '價格波動',
    s1_vol: '成交量',
    s1_depth: '訂單簿深度',
    s1_trigger: '觸發條件：波動 ≥ 100 USD',
    s1_met: '已滿足',
    s2_title: 'PolyAi-Claw Engine',
    s2_sub: 'AI概率計算',
    s2_marketImplied: '市場隱含概率',
    s2_aiTrue: 'AI真實概率',
    s2_yes: 'YES',
    s2_probDiff: '概率差優勢',
    s2_safe: '進入安全交易區',
    s3_title: 'Auto Trade + Profit',
    s3_sub: '自動執行與收益',
    s3_exec: '交易執行',
    s3_buyYes: '買入 YES',
    s3_buyPrice: '買入價格',
    s3_settlement: '預測市場結算',
    s3_correct: '正確預測',
    s3_profit: '單筆收益',
    s3_avg: '平均收益率',
    s3_recycle: '收益回收資金池',
    chart_title: 'AI概率 vs 市場概率 偏差圖',
    chart_sub: '實時追蹤 Poly Ai Claw 智能體引擎與市場定價的概率偏差，識別套利視窗',
    chart_live: 'Live Analysis',
    chart_curDev: '當前偏差',
    chart_signal: '套利信號',
    chart_signalVal: '觸發',
    chart_winRate: '勝率預測',
    chart_bottom_implied: '市場隱含概率',
    chart_bottom_dev: '概率偏差區域',
    chart_bottom_dev_sub: '套利機會已觸發',
    chart_bottom_ai: 'AI 真實概率',
    chart_bottom_ai_sub: 'Poly Ai Claw 模型輸出',
    chart_bottom_implied_sub: '基於市場價格定價',
    chart_marketProb: '市場隱含概率',
    chart_aiProb: 'AI 真實概率',
    chart_deviationArea: '套利偏差區域',
    maxDeviation: '最大偏差',
    deviation: '偏差',
    flow_title: '完整策略流程',
    flow0_title: 'BTC數據監控',
    flow0_desc: '實時價格/成交量',
    flow1_title: '波動檢測',
    flow1_desc: '≥ 100 USD',
    flow2_title: '時間過濾',
    flow2_desc: '最後60秒',
    flow3_title: '勝率評估',
    flow3_desc: '≥ 60-70%',
    flow4_title: '自動執行',
    flow4_desc: '買入 YES/NO',
    flow5_title: '市場結算',
    flow5_desc: '1 USDC',
    flow6_title: '收益複利',
    flow6_desc: '3%-10%',
    risk0_title: '風控結構',
    risk0_i0: '單事件資金限制 < 5%',
    risk0_i1: '多事件分散交易',
    risk0_i2: 'AI動態止損',
    risk1_title: '時間策略',
    risk1_i0: '最後60秒執行',
    risk1_i1: '避免情緒交易',
    risk1_i2: '信息更完整',
    risk2_title: '歷史表現',
    risk2_i0: '歷史勝率 80%-90%',
    risk2_i1: '平均收益 3%-10%',
    risk2_i2: '穩定套利模型',
  },
  crossPlatform: {
    badge: '跨預測平台套利',
    title1: 'PolyAi CLaw',
    title2: '預測市場跨平台套利邏輯',
    desc: '橋接 Polymarket（Web3）與 Kalshi（法幣）雙平台，捕獲價格偏差，實現智能匹配 + 極速執行',
    polymarket: 'Polymarket',
    kalshi: 'Kalshi',
    web3: 'Web3',
    fiat: '法幣',
    claw: 'CLaw',
    matched: '✓ 已匹配',
    matching: '匹配中...',
    sec1_badge: '01',
    sec1_accuracy: '99%+ 精準度',
    sec1_title: '智能市場匹配',
    sec1_desc: '兩個平台的事件通過語義 AI 自動綁定，毫秒級識別跨平台同標的價差',
    sec2_badge: '02',
    sec2_ms: '毫秒級執行',
    sec2_title: '統一集成與極速交易',
    sec2_desc: '統一 API/SDK 連接多平台，毫秒級同步下單，確保套利視窗零延誤捕獲',
    connected: '已連接 · 實時',
    latency: '下單延遲',
    dailyEvents: '每日匹配事件',
    successRate: '執行成功率',
    platforms: '同步平台數',
    sec3_badge: '03',
    sec3_analytics: 'Live Analytics',
    sec3_title: '套利數據可視化',
    sec3_desc: '實時價格偏差、套利收益與增長趨勢，動態呈現跨平台套利價值',
    priceDeviation: '價格偏差分佈',
    volumeTitle: '月度交易量 (K USDC)',
    h1Volume: 'H1 累計交易量 (USDC)',
    arbIndicators: '套利優勢指標',
    arbSuccess: '價差套利成功率',
    semanticAccuracy: '語義匹配精準度',
    liquidity: '跨平台流動性',
    hedgeCoverage: '風險對沖覆蓋率',
  },
  mathAlgo: {
    badge: '精密的高級數學算法',
    title1: 'Polymarket 套利並不是',
    title2: '簡單的數學問題',
    quote: '當你還在手動算這道加法題的時候，量化系統已經在做一件完全不同的事。',
    quoteHighlight1: '手動算這道加法題',
    quoteHighlight2: '完全不同的事',
    ch0_title: '套利是什麼？為什麼 Polymarket 有這麼多',
    ch0_tag: '市場低效',
    ch1_title: '跨市場套利：邏輯依賴關係',
    ch1_tag: '組合數學',
    ch2_title: 'Bregman 投影：算出最優套利量',
    ch2_tag: '凸優化',
    pipeline_title: 'Polymarket 套利系統 — 完整架構',
    layer0: '第一層：數據採集',
    layer1: '第二層：依賴關係檢測',
    layer2: '第三層：三級優化引擎',
    layer3: '第四層：執行與倉位管理',
    annualProfit: '年度總提取利潤：$39,688,585',
    venn_title: '邏輯依賴關係：P(大勝 5%) ⊆ P(獲勝)',
    contradiction: '矛盾！P(子集) > P(父集) → 套利信號觸發',
    contradiction_sub: '0.55 > 0.48 → 邏輯矛盾 → 套利機會',
    combinations: '組合市場數量',
    brutal: '暴力枚舉不可能',
    integerConstraints: '整數規劃約束',
    replaces: '替代 16,384 次枚舉',
    bregman_title: 'KL 散度 vs 歐幾里得距離',
    coreData: '核心數據',
    pipeline4: '系統四層管道',
    annualReturn: '年化利潤 ≈ $3,968 萬',
    whyNotEnough_title: '為什麼「價格相加 = $1」不夠用？',
    singleMarket: '單市場——表面正常',
    crossMarket: '跨市場——指數爆炸',
  },
  mathProfit: {
    ch3_title: 'Frank-Wolfe 算法：一步一步逼近答案',
    ch3_tag: '迭代算法',
    ch3_chapter: '第04章',
    execTitle: '非原子執行風險',
    profitStructure: '利潤結構（2024.4 – 2025.4）',
    totalProfit: '總計：$39,688,585',
    top10: '其中 TOP 10 拿走 20.5%',
    kellyFormula: '改良 Kelly 倉位公式',
    preTrade: '執行前 4 道門檻',
    gate0: '流動性充足？',
    gate1: '滑點可接受？',
    gate2: '扣滑點仍盈利？',
    gate3: '利潤 > $0.05 → 執行',
  },
  safuFund: {
    badge: '資產安全保障',
    title: 'Polywin SAFU 基金',
    titleHighlight: 'SAFU 基金',
    desc: '鏈上鎖定儲備，公開透明，實時可查 — 你的資產，我們守護',
    reserveLabel: 'Total Reserve · USDC · Ethereum Mainnet',
    verified: '鏈上已驗證',
    mainDesc: 'Polywin 團隊已在以太坊主網鏈上鎖定 1000 萬 USDC SAFU 安全儲備基金，專項用於黑客攻擊下的用戶資產兜底保障。',
    mainDescHighlight: '1000 萬 USDC',
    contractLabel: '合約地址',
    etherscanBtn: 'Etherscan 驗證',
    stat0_label: '儲備規模',
    stat0_sub: 'USDC',
    stat1_label: '鏈上鎖定率',
    stat1_sub: 'On-Chain',
    stat2_label: '可查時間',
    stat2_sub: 'Real-time',
    stat3_label: '歷史賠付',
    stat3_val: '$0',
    stat3_sub: '零損失記錄',
    f0_title: '鏈上鎖定',
    f0_desc: '資金 100% 鎖定於以太坊主網智能合約，團隊無權隨意提取或轉移',
    f1_title: '公開透明',
    f1_desc: '任何人可通過 Etherscan 實時查看資金餘額與所有歷史交易記錄',
    f2_title: '極速賠付',
    f2_desc: '安全事件確認後 72 小時內啟動賠付流程，用戶資產第一時間兜底',
    f3_title: '獨立審計',
    f3_desc: '第三方安全機構定期審計合約代碼，確保儲備金真實可信不作假',
  },
  cta: {
    badge: '立即開始',
    title1: '開始使用',
    title2: 'Poly Ai Claw',
    title3: '智能體引擎',
    desc: '無需編程經驗，3 分鐘完成 AI 策略配置',
    btn: '啟動 AI-Claw',
    trust0: 'Polygon 官方合作',
    trust1: '審計機構認證',
    trust2: '10,000+ 活躍用戶',
    trust3: '$50M+ 累計交易額',
  },
  footer: {
    tagline: 'Poly Ai Claw 智能體引擎',
    product: '產品',
    resources: '資源',
    social: '社交媒體',
    link0: 'Poly AI-Claw 算法',
    link1: '風控系統',
    link2: '數據 API',
    link3: '開發文檔',
    res0: '使用教程',
    res1: '策略案例',
    res2: '白皮書',
    res3: '社區論壇',
    copyright: '© 2026 PolyWin. All rights reserved.',
    privacy: '隱私政策',
    terms: '服務條款',
  },
};
